export class FavoriteListAccessDeniedError extends Error {
  constructor(
    public favoriteListId: string,
    public requiredAccess: 'read' | 'edit' | 'owner'
  ) {
    super(
      `Access denied: '${requiredAccess}' access is required for favorite list ${favoriteListId}.`
    )
  }
}
